export const DEFAULT_MAX_PROGRESS_VALUE = 100;
export const PERCENTAGE_100 = 100;
